import { render, staticRenderFns } from "./OpenBox.vue?vue&type=template&id=0c6e5a88&scoped=true&"
import script from "./OpenBox.vue?vue&type=script&lang=js&"
export * from "./OpenBox.vue?vue&type=script&lang=js&"
import style0 from "./OpenBox.vue?vue&type=style&index=0&id=0c6e5a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.12_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e5a88",
  null
  
)

export default component.exports